module.exports = __webpack_public_path__ + "f5ccff7c2f3ded1ce639e0209f3a8b6e.svg";